// extracted by mini-css-extract-plugin
export default {"headerFixed":"EditActivity_headerFixed__1LwoM","header":"EditActivity_header__eUrhD"};